<template>
    <TheGuidelinesLayout v-if="guideline">
        <BaseSection>
            <template #title>
                <h2>Appendices</h2>
            </template>

            <template #default>
                <BaseFileList
                    v-if="!pending"
                    :files="appendices"
                />

                <content-placeholders v-if="pending">
                    <content-placeholders-text :lines="6" />
                </content-placeholders>

                <p v-if="(!appendices || !appendices.length) && !pending">
                    Sorry, this guideline does not have any appendices available.
                </p>
            </template>
        </BaseSection>

        <BaseSection>
            <template #title>
                <h2>Peer Reviewed Publications</h2>
            </template>

            <template #default>
                <BaseFileList
                    v-if="!pending"
                    :files="publications"
                />

                <content-placeholders v-if="pending">
                    <content-placeholders-text :lines="6" />
                </content-placeholders>

                <p v-if="(!publications || !publications.length) && !pending">
                    Sorry, this guideline does not have any peer reviewed publications available.
                </p>
            </template>
        </BaseSection>
    </TheGuidelinesLayout>
</template>

<script setup>
import GuidelinePublicationsAndAppendicesQuery from '~/graphql/queries/guidelines/publications-appendices.graphql';

const props = defineProps({
    guideline: {
        type: Object,
        required: true,
        default: null
    }
});

const response = await useLazyAsyncQuery({
    query: GuidelinePublicationsAndAppendicesQuery,
    variables: {
        id: Number(props.guideline?.id)
    }
});

const { data, pending } = response;

const publications = computed(() => {
    if (data?.value?.entry?.publications) {
        return data.value.entry.publications;
    }
    return null;
});

const appendices = computed(() => {
    if (data?.value?.entry?.appendices) {
        return data.value.entry.appendices;
    }
    return null;
});



const seo = computed(() => {
    if (!props.guideline?.seo) {
        return;
    }

    return useSeo(props.guideline.seo, props.guideline);
});

// todo - guidelines are not yet available for multisite's
useHead({
    title: `Publications and Appendices of the ${props.guideline.title} guideline - Uroweb`,
    meta: seo.value.meta
});
</script>
